<template>
    <div :class="getCSSClass('model-manager-header-buttons-container')">
        <button type="button"
                :class="getCSSClass('model-manager-new-button')"
                @click="emitCopy"
                v-html="icon('calendar')+translate('Új próba meglévő másolatával')"></button>
        <button type="button"
                :class="getCSSClass('model-manager-new-button')"
                @click="emitNew"
                v-html="icon('calendar')+translate('Új próba')"></button>
        <button type="button"
                :class="getCSSClass('model-manager-new-button')"
                @click="emitMail"
                v-html="icon('mail')+translate('Próbarend kiküldése e-mailben')"></button>
    </div>
</template>

<script>
    export default {
        inject: ['getCSSClass', 'loadingIndicator', 'icon', 'locale', 'translate'],
        props: {
            buttons: {type: Object},
        },
        data: function () {
            return {}
        },
        mounted() {
        },
        methods: {
            emitNew: function() {
                this.$emit('new');
            },
            emitCopy: function() {
                this.$emit('component', {subComponents: {'editFormComponent': 'CopyRehearsalComponent'}});
                window.setTimeout(() => {
                    this.emitNew();
                }, 200);
            },
            emitMail: function() {
                this.$emit('component', {subComponents: {'editFormComponent': 'ScheduleMailer'}});
                window.setTimeout(() => {
                    this.emitNew();
                }, 200);
            }
        },
        computed: {},
        watch: {}

    }
</script>
